'use strict';
import Quotations from './resources/Quotations';
import Orders from './resources/Orders';
const resources = {
    Quotations,
    Orders,
};
export default resources;
//# sourceMappingURL=resources.js.map